import { Box } from "theme-ui"

export default function Option({ children, ...otherProps }) {
  return (
    <Box as="option" {...otherProps}>
      {children}
    </Box>
  )
}
